module.exports = __webpack_public_path__ + "media/screenshot@2x_3433ba.png";